import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = ['input', 'dropzone', 'preview', 'message'];

  initialize() {
    this.showPreview = this.showPreview.bind(this);
    this.hidePreview = this.hidePreview.bind(this);
    this.toggleDropzoneHoverStyles = this.toggleDropzoneHoverStyles.bind(this);
    this.directUploadError = this.directUploadError.bind(this);
  }

  connect() {
    useEventListener(this, this.inputTarget, 'change', this.showPreview);
    useEventListener(this, this.previewTarget, 'error', this.hidePreview);
    useEventListener(this, this.inputTarget, 'direct-upload:error', this.directUploadError);

    const xhr = new XMLHttpRequest();

    if (this.dropzoneTarget && xhr.upload) {
      useEventListener(this, document, 'dragover', (e) => this.toggleDropzoneHoverStyles(e, true));
      useEventListener(this, document, 'dragleave', (e) => this.toggleDropzoneHoverStyles(e, false));
    }
  }

  supportsImagePreview() {
    return 'FileReader' in window;
  }

  toggleDropzoneHoverStyles(e, hovering) {
    if (e.target === this.dropzoneTarget) {
      if (hovering) {
        this.dropzoneTarget.classlist.add('border-dark-knight');
      } else {
        this.dropzoneTarget.classlist.remove('border-dark-knight');
      }
    }
  }

  showPreview() {
    const { files } = this.inputTarget;

    if (!this.supportsImagePreview() || !files.length) { // FileReader API not supported or no file
      return;
    }

    const file = files[0];
    if (this.hasMessageTarget) {
      this.messageTarget.classList.add('hidden');
      this.messageTarget.textContent = '';
    }
    if (file.size > 1024 * 1024) { // 1MB limit
      if (this.hasMessageTarget) {
        this.messageTarget.textContent = 'File size cannot exceed 1MB';
        this.messageTarget.classList.remove('hidden');
      }
      this.inputTarget.value = '';
      return;
    }
    const reader = new FileReader();
    reader.onerror = (e) => {
      // eslint-disable-next-line no-console
      console.log('Err', e);
    };
    reader.onload = (e) => {
      if (e.target && e.target.result) {
        this.previewTarget.src = e.target.result;
        if (this.previewTarget.classList.contains('hidden')) {
          this.previewTarget.classList.remove('hidden');
          if (this.dropzoneTarget) {
            this.dropzoneTarget.classList.add('hidden');
          }
        }
      }
    };
    reader.readAsDataURL(file); // convert to base64 string
  }

  hidePreview() {
    this.previewTarget.src = '';
    this.previewTarget.classList.add('hidden');
    if (this.dropzoneTarget) {
      this.dropzoneTarget.classList.remove('hidden');
    }
  }

  directUploadError() {
    if (this.hasMessageTarget) {
      this.messageTarget.textContent = 'File failed to upload';
      this.messageTarget.classList.remove('hidden');
    }
  }
}
